/* eslint-env browser */
import * as React from 'react'
import PropTypes from 'prop-types'
import isEmail from 'validator/lib/isEmail'
import request from 'axios'
import withTranslator from '../TranslatorProvider'

const AnalyticsService = require('../../../../common/client/analytics.js')

class LoginForm extends React.Component {
  constructor() {
    super()
    this.state = {
      firstName: '',
      firstNameStarted: false,
      lastName: '',
      lastNameStarted: false,
      email: '',
      emailStarted: false,
      password: '',
      passwordStarted: false,
      disableEmailMarketing: true,
      incompleteFormError: false,
      isFormCompletedOnce: false,
    }
    this.handleChange = this.handleChange.bind(this)
    this.validationState = this.validationState.bind(this)
    this.isSignupButtonEnabled = this.isSignupButtonEnabled.bind(this)
    this.isBaseFormComplete = this.isBaseFormComplete.bind(this)
    this.submit = this.submit.bind(this)
  }

  handleChange() {
    const isBaseFormComplete = this.isBaseFormComplete()
    const isFormValid = this.isSignupButtonEnabled()

    this.setState(prevState => ({
      incompleteFormError: prevState.incompleteFormError && !isFormValid,
      isFormCompletedOnce: prevState.isFormCompletedOnce || isBaseFormComplete,
    }))
  }

  validationState(formElementName) {
    const {
      firstName,
      lastName,
      password,
      email,
      firstNameStarted,
      lastNameStarted,
      emailStarted,
      passwordStarted,
    } = this.state

    if (formElementName === 'firstName') {
      if (firstNameStarted && firstName.length === 0) {
        return 'error'
      }
    } else if (formElementName === 'lastName') {
      if (lastNameStarted && lastName.length === 0) {
        return 'error'
      }
    } else if (formElementName === 'email') {
      if (emailStarted && !isEmail(email)) {
        return 'error'
      }
    } else if (formElementName === 'password') {
      if (passwordStarted && password.length < 6) {
        return 'error'
      }
    }
    return undefined
  }

  signupButtonTitle() {
    const { isSubmitting } = this.state
    return isSubmitting
      ? this.getLabel('landing.register.submit.loading')
      : this.getLabel('landing.register.submit.signup')
  }

  isSignupButtonEnabled() {
    const { isSubmitting, firstNameStarted, lastNameStarted, emailStarted, passwordStarted, cgusAccepted } = this.state

    if (isSubmitting) {
      return false
    }
    if (!firstNameStarted || !lastNameStarted || !emailStarted || !passwordStarted) {
      return false
    }
    if (cgusAccepted !== true) {
      return false
    }

    const elementNames = ['firstName', 'lastName', 'email', 'password']
    const isInvalid = elementNames.some(e => typeof this.validationState(e) !== 'undefined')
    if (isInvalid) {
      return false
    }
    return true
  }

  isBaseFormComplete() {
    const { firstNameStarted, lastNameStarted, emailStarted, passwordStarted } = this.state

    if (!firstNameStarted || !lastNameStarted || !emailStarted || !passwordStarted) {
      return false
    }

    const elementNames = ['firstName', 'lastName', 'email', 'password']
    const isInvalid = elementNames.some(e => typeof this.validationState(e) !== 'undefined')
    if (isInvalid) {
      return false
    }
    return true
  }

  submit(e) {
    e.preventDefault()

    if (!this.isSignupButtonEnabled()) {
      this.setState({
        incompleteFormError: true,
      })
      return
    }

    const { isSubmitting, successMessage } = this.state

    if (isSubmitting || typeof successMessage !== 'undefined') {
      return
    }
    const newState = this.state
    newState.errorMessage = undefined
    newState.successMessage = undefined
    newState.isSubmitting = true
    this.setState(newState)

    const sendPecheurPromoCodeWhenRegistering = window._sendPecheurPromoCodeWhenRegistering === true
    const sendPecheurPromoCodeWhenRegisteringProductArticleId =
      window._sendPecheurPromoCodeWhenRegisteringProductArticleId

    request
      .post('/api/users', this.state, {
        params: { sendPecheurPromoCodeWhenRegistering, sendPecheurPromoCodeWhenRegisteringProductArticleId },
      })
      .then(() => {
        try {
          window.fbq('track', 'CompleteRegistration')
        } catch (e2) {
          // error silenced
        }

        const newState2 = this.state
        newState2.isSubmitting = false
        newState2.successMessage = 'form.successMessage'
        this.setState(newState2)
      })
      .catch(err => {
        const newState3 = this.state
        newState3.isSubmitting = false
        newState3.errorMessage = 'loginError.errorSystem'

        if (err.response && err.response.status === 409 && err.response.data && err.response.data.cause) {
          newState3.errorMessage = `registerError.${err.response.data.cause}`
        }
        this.setState(newState3)
      })
  }

  render() {
    const { translate } = this.props

    const emailError = this.validationState('email')
    const passwordError = this.validationState('password')
    const { isSubmitting, successMessage, errorMessage, incompleteFormError, isFormCompletedOnce } = this.state
    const { isInline } = this.props

    const isFormComplete = this.isBaseFormComplete()

    const idPrefix = isInline ? 'inline-' : 'modal-'

    return (
      <form className="form" onSubmit={this.submit}>
        <div className="field is-horizontal">
          {/*! isInline && (
            <div className="field-label is-normal">
              <label className="label" htmlFor={`${idPrefix}input-register-firstName`}>
                {translate('loginSignup.form.firstName.title')}
              </label>
            </div>
          ) */}
          <div className="field-body">
            <div className="field">
              <p className="control is-expanded has-icons-left">
                <input
                  className="input"
                  name={`${idPrefix}firtstname`}
                  type="text"
                  id={`${idPrefix}input-register-firstName`}
                  placeholder={translate('loginSignup.form.firstName.title')}
                  autoCorrect="off"
                  autoCapitalize="off"
                  ref={c => {
                    this.firstNameInput = c
                  }}
                  onChange={e => {
                    this.setState({ firstName: e.target.value, firstNameStarted: true }, this.handleChange)
                  }}
                />
                <span className="icon is-small is-left">
                  <i className="fas fa-user-tag" />
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="field is-horizontal">
          {/*! isInline && (
            <div className="field-label is-normal">
              <label className="label" htmlFor={`${idPrefix}input-register-lastName`}>
                {translate('loginSignup.form.lastName.title')}
              </label>
            </div>
          ) */}
          <div className="field-body">
            <div className="field">
              <p className="control is-expanded has-icons-left">
                <input
                  className="input"
                  type="text"
                  name={`${idPrefix}lastname`}
                  id={`${idPrefix}input-register-lastName`}
                  placeholder={translate('loginSignup.form.lastName.title')}
                  autoCorrect="off"
                  autoCapitalize="off"
                  ref={c => {
                    this.lastNameInput = c
                  }}
                  onChange={e => {
                    this.setState({ lastName: e.target.value, lastNameStarted: true }, this.handleChange)
                  }}
                />
                <span className="icon is-small is-left">
                  <i className="fas fa-user-tag" />
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="field is-horizontal">
          {/*! isInline && (
            <div className="field-label is-normal">
              <label className="label" htmlFor={`${idPrefix}input-register-email`}>
                {translate('loginSignup.form.email.title')}
              </label>
            </div>
          ) */}
          <div className="field-body">
            <div className="field">
              <p className="control is-expanded has-icons-left">
                <input
                  className={`input ${emailError ? 'is-danger' : ''}`}
                  type="email"
                  name={`${idPrefix}email`}
                  id={`${idPrefix}input-register-email`}
                  placeholder={translate('loginSignup.form.email.title')}
                  autoCorrect="off"
                  autoCapitalize="off"
                  ref={c => {
                    this.emailInput = c
                  }}
                  onChange={e => {
                    this.setState({ email: e.target.value, emailStarted: true }, this.handleChange)
                  }}
                />
                <span className="icon is-small is-left">
                  <i className="fas fa-envelope" />
                </span>
              </p>
              {emailError && (
                <p className={`help is-danger has-text-weight-bold ${isInline ? ' has-text-white' : ''}`}>
                  {translate('loginSignup.form.email.error')}
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="field is-horizontal">
          {/*! isInline && (
            <div className="field-label is-normal">
              <label className="label" htmlFor={`${idPrefix}input-register-password`}>
                {translate('loginSignup.form.password.title')}
              </label>
            </div>
          ) */}
          <div className="field-body">
            <div className="field">
              <p className="control is-expanded has-icons-left">
                <input
                  className={`input ${passwordError ? 'is-danger' : ''}`}
                  type="password"
                  name={`${idPrefix}password`}
                  id={`${idPrefix}input-register-password`}
                  placeholder={translate('loginSignup.form.password.title')}
                  autoCorrect="off"
                  autoCapitalize="off"
                  ref={c => {
                    this.passwordInput = c
                  }}
                  onChange={e => {
                    this.setState({ password: e.target.value, passwordStarted: true }, this.handleChange)
                  }}
                />
                <span className="icon is-small is-left">
                  <i className="fas fa-lock" />
                </span>
              </p>
              {passwordError && (
                <p className={`help is-danger has-text-weight-bold ${isInline ? ' has-text-white' : ''}`}>
                  {translate('loginSignup.form.password.error')}
                </p>
              )}
            </div>
          </div>
        </div>

        {!successMessage && (!isInline || isFormCompletedOnce || isFormComplete) && (
          <div className={`field is-horizontal ${isInline ? 'animated slideInUp faster box grey-background' : ''}`}>
            {/*! isInline && <div className="field-label is-normal" /> */}
            <div className="field-body">
              <input
                className="is-checkradio is-medium"
                id={`${idPrefix}checkboxNewsletter`}
                type="checkbox"
                name={`${idPrefix}checkboxNewsletter`}
                onChange={e => {
                  this.setState({ disableEmailMarketing: !e.target.checked }, this.handleChange)
                }}
              />
              <label className="has-text-left is-size-7 has-text-weight-bold" htmlFor={`${idPrefix}checkboxNewsletter`}>
                <span dangerouslySetInnerHTML={{ __html: translate('loginSignup.form.acceptNewsletter.title') }} />
              </label>
            </div>
          </div>
        )}

        {!successMessage && (!isInline || isFormCompletedOnce || isFormComplete) && (
          <div className={`field is-horizontal ${isInline ? 'animated slideInUp faster box grey-background' : ''}`}>
            {/*! isInline && <div className="field-label is-normal" /> */}
            <div className="field-body">
              <input
                className="is-checkradio is-medium"
                id={`${idPrefix}checkboxCGGUs`}
                type="checkbox"
                name={`${idPrefix}checkboxCGGUs`}
                onChange={e => {
                  this.setState({ cgusAccepted: e.target.checked }, this.handleChange)
                }}
              />
              <label className="has-text-left is-size-7 has-text-weight-bold" htmlFor={`${idPrefix}checkboxCGGUs`}>
                <span dangerouslySetInnerHTML={{ __html: translate('loginSignup.form.acceptCGUS.title') }} />
              </label>
            </div>
          </div>
        )}

        {(incompleteFormError || errorMessage) && (
          <div className="field is-horizontal animated shake faster">
            {/*! isInline && <div className="field-label" /> */}
            <div className="field-body">
              <div className="field">
                <div className="control">
                  <div className="notification is-danger">
                    {incompleteFormError
                      ? translate('loginSignup.registerError.incompleteForm')
                      : translate(`loginSignup.${errorMessage}`)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {successMessage && (
          <div className="field is-horizontal animated slideInUp faster">
            {/*! isInline && <div className="field-label" /> */}
            <div className="field-body">
              <div className="field">
                <div className="control">
                  <div
                    className="notification is-success"
                    dangerouslySetInnerHTML={{ __html: translate(`loginSignup.${successMessage}`) }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {!successMessage && (
          <div className="field is-horizontal">
            {/*! isInline && <div className="field-label" /> */}
            <div className="field-body">
              <div className="field">
                <div className="control has-text-centered">
                  <button
                    type="submit"
                    onClick={AnalyticsService.trackEvent('REGISTER_EMAIL_PASSWORD')}
                    className={`button is-call-to-action ${isSubmitting ? 'is-loading' : ''}`}
                    style={{ minWidth: 290 }}
                  >
                    {translate('loginSignup.form.signupButton')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </form>
    )
  }
}
LoginForm.propTypes = {
  translate: PropTypes.func.isRequired,
  isInline: PropTypes.bool,
}

LoginForm.defaultProps = {
  isInline: false,
}

module.exports = withTranslator(LoginForm)
